import { DraftsRounded } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";
import renovation9 from "../images/renovation/renovation9.jpg";
import director1 from "../images/director1.png";
import director2 from "../images/director2.jpg";

const initialState = {
  // Hero Section Data
  hero: {
    title:
      "Designs that speak luxury, rooted in concept and crafted with purpose.",
    subtitle:
      "Design is not just what a space looks like — it’s how it feels, flows, and supports everyday life.",
    backgroundImage: `${renovation9}`,
    foundedYear: "2020",
    buttons: [
      {
        id: 1,
        text: "Get in Touch",
        variant: "contained",
        icon: "ArrowForwardIcon",
        color: "#FF6B35",
        navigateTo: "/contact",
      },
      {
        id: 2,
        text: "View Our Work",
        variant: "outlined",
        navigateTo: "/services",
      },
    ],
  },

  // New: CollegeDekho Style Features Section
  features: [
    {
      id: 1,
      title: "Get Your Career Match",
      description:
        "Take our free career compass personality quiz and get top career options for you.",
      icon: "PsychologyIcon",
      color: "#e0e0e0",
      iconColor: "#e0e0e0",
    },
    {
      id: 2,
      title: "Talk to Admission Experts",
      description:
        "Get free personalised expert guidance on colleges & courses",
      icon: "GroupsIcon",
      color: "#e0e0e0",
      iconColor: "#e0e0e0",
    },
    {
      id: 3,
      title: "Apply With One Form",
      description: "One platform to apply to 2000+ esteemed colleges",
      icon: "DescriptionIcon",
      color: "#e0e0e0",
      iconColor: "#e0e0e0",
    },
    {
      id: 4,
      title: "Easy Apply in 5 mins",
      description: "Fill your college applications in 5 minutes or less.",
      icon: "AccessTimeIcon",
      color: "#e0e0e0",
      iconColor: "#e0e0e0",
    },
  ],

  // Mission & Vision Data
  missionVision: {
    mission: {
      title: "Our Mission",
      description:
        "Our mission is to create thoughtfully designed interiors that balance concept, functionality, and emotion.",
      description2:
        "We aim to understand our clients deeply — their lifestyle, needs, and aspirations — and translate that understanding into spaces that feel intuitive, comfortable, and refined.Through clear planning, honest communication, and careful execution, we deliver designs that are personal, purposeful, and built to las.",
      image:
        "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: "FlagIcon",
      color: "#FF6B35",
      details: [
        "Create personalized design solutions tailored to each client's unique needs",
        "Integrate functionality with aesthetics for practical yet beautiful spaces",
        "Source sustainable materials and implement eco-friendly design practices",
        "Provide end-to-end project management for seamless execution",
        "Stay ahead of design trends while maintaining timeless appeal",
      ],
    },
    vision: {
      title: "Our Vision",
      description:
        "To be the most trusted and innovative interior design studio, recognized globally for creating spaces that inspire, uplift, and stand the test of time. We envision a world where every environment is thoughtfully designed to enhance human experience.",
      icon: "VisibilityIcon",
      color: "#eaefefff",
      goals: [
        {
          id: 1,
          title: "Global Recognition",
          description:
            "Expand our influence internationally while maintaining our commitment to quality",
          icon: "EmojiEventsIcon",
          color: "#f1edecff",
        },
        {
          id: 2,
          title: "Sustainable Design",
          description:
            "Lead the industry in eco-friendly and sustainable interior solutions",
          icon: "FavoriteIcon",
          color: "#fdfefeff",
        },
        {
          id: 3,
          title: "Technological Innovation",
          description:
            "Integrate cutting-edge technology into the design process",
          icon: "LightbulbIcon",
          color: "#eff2f7ff",
        },
        {
          id: 4,
          title: "Community Impact",
          description:
            "Create spaces that positively impact communities and wellbeing",
          icon: "GroupsIcon",
          color: "#efede8ff",
        },
      ],
    },
  },

  // Statistics Data
  statistics: [
    {
      id: 1,
      number: "8",
      label: "Years of Excellence",
      icon: "HistoryIcon",
      color: "#e5e3e2ff",
    },
    {
      id: 2,
      number: "50+",
      label: "Projects Completed",
      icon: "CheckCircleIcon",
      color: "#f2eeedff",
    },
    {
      id: 3,
      number: "20+",
      label: "Team Members",
      icon: "PeopleIcon",
      color: "#e8e1deff",
    },
    {
      id: 4,
      number: "25+",
      label: "Awards Won",
      icon: "EmojiEventsIcon",
      color: "#ede1ddff",
    },
  ],

  // Founders Data
  founders: [
    {
      id: 1,
      name: "Suman Kumar Das",
      role: "Co-founder & Technical Director",
      bio: "“The Co-Founder is an experienced Admission Consultant with 18 years of expertise in college admissions and student counseling. Alongside this, they possess strong experience in technical services, real estate consulting, and creative decoration solutions. This multi-industry exposure enables well-rounded guidance, efficient execution, and reliable outcomes.”",
      experienceYears: "18+",
      funFact:
        "Enjoys rock climbing and has a deep passion for collecting vinyl records.",
      initials: "SKD",
      social: {
        linkedin: "https://www.linkedin.com/in/suman-kumar-das-ba5a44110/",
        twitter: "#",
        instagram: "#",
      },
      image: director1,
      color: "#FF6B35",
    },
    {
      id: 2,
      name: "Arpita Bisai",
      role: "Co-Founder & Creative Director",
      bio: "“A creative visionary with expertise in digital design and interior aesthetics, Arpita Bisai leads with a refined balance of creativity and functionality. Her fine arts foundation and design sensibility shape elegant spaces and impactful visual identities that elevate both brands and environments.”",
      experienceYears: "8+",
      funFact:
        "Loves the balance of chess strategy and designing serene, plant-inspired spaces.",
      initials: "AB",
      social: {
        linkedin: "https://www.linkedin.com/in/arpita-bisai-728277224",
        twitter: "#",
        instagram: "#",
      },
      image: director2,
      color: "#008C9E",
    },
  ],

  teamMembers: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Founder & Creative Director",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      experience: "15+ Years",
      specialty: "Luxury Residential",
      description:
        "Sarah founded Decodia with a vision to create spaces that tell stories. Her designs have won multiple international awards.",
      social: {
        instagram: "sarah_johnson",
        linkedin: "sarahjohnson",
      },
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Senior Interior Architect",
      image:
        "https://images.unsplash.com/photo-1582750433449-648ed127bb54?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      experience: "12+ Years",
      specialty: "Commercial Spaces",
      description:
        "Michael specializes in creating functional yet beautiful commercial environments that enhance productivity.",
      social: {
        linkedin: "michaelchen",
        twitter: "michaelchen_design",
      },
    },
    {
      id: 3,
      name: "Priya Sharma",
      role: "Residential Design Lead",
      image:
        "https://images.unsplash.com/photo-1580894732444-8ecded7900cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      experience: "10+ Years",
      specialty: "Modern Minimalism",
      description:
        "Priya believes in the beauty of simplicity. Her minimalist designs create calm, organized living spaces.",
      social: {
        instagram: "priya_sharma_design",
        pinterest: "priyasharma",
      },
    },
    {
      id: 4,
      name: "David Wilson",
      role: "Project Manager",
      image:
        "https://images.unsplash.com/photo-1551836026-d5c2c1b49c46?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      experience: "8+ Years",
      specialty: "Renovation Projects",
      description:
        "David ensures every project runs smoothly from concept to completion, managing timelines and budgets.",
      social: {
        linkedin: "davidwilson",
        facebook: "davidwilsonpm",
      },
    },
  ],

  // Company Values Data
  values: [
    {
      id: 1,
      title: "Excellence",
      description:
        "We strive for excellence in every detail, ensuring the highest quality in design and execution.",
      icon: "StarIcon",
      color: "#FF6B35",
    },
    {
      id: 2,
      title: "Innovation",
      description:
        "We embrace innovative design solutions and stay ahead of industry trends and technologies.",
      icon: "DesignServicesIcon",
      color: "#008C9E",
    },
    {
      id: 3,
      title: "Collaboration",
      description:
        "We work closely with clients, architects, and contractors to ensure seamless project delivery.",
      icon: "GroupsIcon",
      color: "#1D3557",
    },
    {
      id: 4,
      title: "Integrity",
      description:
        "We maintain transparency, honesty, and ethical practices in all our business dealings.",
      icon: "VerifiedUserIcon",
      color: "#695424ff",
    },
  ],

  // Timeline Data
  timeline: [
    {
      id: 1,
      year: "2010",
      title: "Company Founded",
      description:
        "Decodia Interior Design Studio was founded with a vision to transform spaces into experiences.",
    },
    {
      id: 2,
      year: "2013",
      title: "First Award Win",
      description:
        "Won 'Best Residential Design' at the International Design Awards for our signature project.",
    },
    {
      id: 3,
      year: "2016",
      title: "Expanded Services",
      description:
        "Launched commercial design division to serve corporate and hospitality clients.",
    },
    {
      id: 4,
      year: "2019",
      title: "Sustainability Focus",
      description:
        "Integrated sustainable design practices and eco-friendly materials into all projects.",
    },
    {
      id: 5,
      year: "2022",
      title: "Digital Transformation",
      description:
        "Introduced virtual reality design experiences and advanced 3D visualization tools.",
    },
    {
      id: 6,
      year: "2024",
      title: "International Recognition",
      description:
        "Featured in Architectural Digest and received global recognition for innovative designs.",
    },
  ],

  // Why Choose Us Data
  whyChooseUs: [
    {
      id: 1,
      title: "Client-Centric Approach",
      description:
        "We listen first, design second. Your needs and preferences guide every decision.",
      color: "#FF6B35",
    },
    {
      id: 2,
      title: "Attention to Detail",
      description:
        "From material selection to final installation, we obsess over every detail.",
      color: "#008C9E",
    },
    {
      id: 3,
      title: "Proven Expertise",
      description:
        "14 years of experience with 500+ successful projects completed.",
      color: "#1D3557",
    },
    {
      id: 4,
      title: "Seamless Process",
      description:
        "A structured 5-step process ensures smooth execution from concept to completion.",
      color: "#695424ff",
    },
  ],

  office: {
    title: "Our Design Studio",
    DraftsRounded: "",
    description:
      "Located in the heart of the design district, our studio is a creative hub where ideas come to life. Visit us to experience our design process firsthand.",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
    backgroundImage:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
    address: "Decodia 703 , 7th Floor\nNH12, Action Area IIE, Newtown",
    hours:
      "Monday - Friday: 9 AM - 6 PM\nSaturday: 10 AM - 4 PM (By appointment)",
    contactInfo: {
      phone: "+91 8100364941",
      email: "info@decodia.com",
    },
    button: {
      text: "Schedule a Visit",
      icon: "ArrowForwardIcon",
      navigateTo: "/contact",
    },
  },

  // CTA Section Data
  cta: {
    title: "Ready to Start Your Design Journey?",
    subtitle:
      "Let's work together to create a space that truly reflects your personality and lifestyle.",
    icon: "ChatBubbleIcon",
    phone: "+91 83708 25457",
  },

  // Social Media Data
  socialMedia: {
    linkedin: "https://linkedin.com/company/decodia",
    twitter: "https://twitter.com/decodia",
    instagram: "https://instagram.com/decodia",
    facebook: "https://facebook.com/decodia",
    pinterest: "https://pinterest.com/decodia",
  },

  loading: false,
  error: null,
  activeSection: "hero",
};

const aboutSlice = createSlice({
  name: "about",
  initialState,
  reducers: {
    // Update hero section
    updateHero: (state, action) => {
      state.hero = { ...state.hero, ...action.payload };
    },

    // Update features section
    updateFeatures: (state, action) => {
      state.features = action.payload;
    },

    // Update mission & vision
    updateMissionVision: (state, action) => {
      state.missionVision = { ...state.missionVision, ...action.payload };
    },

    updateStatistics: (state, action) => {
      state.statistics = action.payload;
    },
    updateFounders: (state, action) => {
      state.founders = action.payload;
    },

    addFounder: (state, action) => {
      state.founders.push({
        id: state.founders.length + 1,
        ...action.payload,
      });
    },
    updateTeamMembers: (state, action) => {
      state.teamMembers = action.payload;
    },

    updateValues: (state, action) => {
      state.values = action.payload;
    },

    // Update timeline
    updateTimeline: (state, action) => {
      state.timeline = action.payload;
    },

    // Update why choose us
    updateWhyChooseUs: (state, action) => {
      state.whyChooseUs = action.payload;
    },

    updateOffice: (state, action) => {
      state.office = { ...state.office, ...action.payload };
    },

    updateCta: (state, action) => {
      state.cta = { ...state.cta, ...action.payload };
    },

    // Update social media
    updateSocialMedia: (state, action) => {
      state.socialMedia = { ...state.socialMedia, ...action.payload };
    },

    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error
    setError: (state, action) => {
      state.error = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Set active section
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },

    // Reset to initial state
    resetAboutData: () => initialState,
  },
});

export const {
  updateHero,
  updateFeatures, // Added
  updateMissionVision,
  updateStatistics,
  updateFounders,
  addFounder,
  updateTeamMembers,
  updateValues,
  updateTimeline,
  updateWhyChooseUs,
  updateOffice,
  updateCta,
  updateSocialMedia,
  setLoading,
  setError,
  clearError,
  setActiveSection,
  resetAboutData,
} = aboutSlice.actions;

export default aboutSlice.reducer;
